import { produce } from 'immer';
import { useCallback } from 'react';
import { NodeStateUpdateType } from 'flow-builder/types/state';
import { getChildEndX, getChildEndY, } from 'flow-builder/utils/canvas/calculateChildPosition/calculateChildPosition';
import { getNodeComponent } from 'flow-builder/utils/node/getNodeComponent/getNodeComponent';
import { getRootTree } from 'flow-builder/utils/node/getNodeTree/getNodeTree';
import { getScopeVars } from 'flow-builder/utils/scopeVars/getScopeVars/getScopeVars';
export function useActionNodeDrop({ props, state, }) {
    const { flow: { attributes }, } = props;
    const { attachState, setAttachState, setNodeState } = state;
    const onActionNodeDrop = useCallback((actionNode) => {
        const { hoveredNodeId } = attachState;
        setAttachState({
            actionNodeId: null,
            hoveredNodeId: null,
            isDragging: false,
        });
        if (!hoveredNodeId) {
            return;
        }
        const { node } = actionNode.props;
        const connectorNodeId = node.id;
        setNodeState(produce((state) => {
            const { relations, connections, changes } = state;
            const { parentId: attachNodeParentId } = relations[connectorNodeId];
            const hoveredNode = relations[hoveredNodeId];
            const { pageX: preCalculatedEndX, pageY: preCalculatedEndY } = hoveredNode;
            if (!attachNodeParentId) {
                throw new Error('Action node is missing parent id');
            }
            changes.unshift(NodeStateUpdateType.NodeConnect);
            const attachNodeParent = relations[attachNodeParentId];
            const updatedAttachNodeParent = getNodeComponent(attributes, attachNodeParent).updateConnection(attachNodeParent, node, hoveredNodeId);
            relations[attachNodeParentId] = updatedAttachNodeParent;
            const { label } = connections[connectorNodeId];
            const { parentId } = relations[connectorNodeId];
            if (parentId) {
                const { children, connections } = relations[parentId];
                const childIndex = children.indexOf(connectorNodeId);
                const connectionIndex = connections.findIndex(({ id, connection }) => (connection || id) === connectorNodeId);
                children.splice(childIndex, 1, hoveredNodeId);
                connections.splice(connectionIndex, 1, {
                    id: hoveredNode.id,
                    connection: hoveredNode.id,
                    label: hoveredNode.connectionLabel,
                });
                relations[hoveredNodeId].parentId = parentId;
                relations[hoveredNodeId].connectionLabel = label || 'arrow';
            }
            connections[hoveredNodeId] = Object.assign(Object.assign({}, connections[connectorNodeId]), { id: hoveredNodeId, target: {
                    height: hoveredNode.height,
                }, endX: getChildEndX(preCalculatedEndX), endY: getChildEndY(preCalculatedEndY) });
            delete relations[connectorNodeId];
            delete connections[connectorNodeId];
            state.scopeVars = getScopeVars(attributes, relations);
            state.rootTree = getRootTree(relations);
        }));
    }, [attachState, setAttachState, attributes, setNodeState]);
    return onActionNodeDrop;
}
